export default {
  heading: {
    widgetName: "hotels",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Browse Certified Super Hotels",
    subHeadline: "Super value, quality and service",
    showMoreURL: "https://www.airasia.com/hotels/en/gb",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `certifiedsuper | Browse Certified Super Hotels`,
      eventLabelCardClick: `certifiedsuper | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `certifiedsuper | headline | {{headline}}`,
      eventLabelView: `certifiedsuper`,
    },
  },

  data: [
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blte4ac1e9a72f6555e/62739c65ce4b5935f3320715/wolo_badge.jpg",
      title: "WOLO Kuala Lumpur",
      subtitle: "Kuala Lumpur, Malaysia",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/IP39808390DS"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt333aec826553d291/62739c656ed4423afc98e296/berjaya_langkawi_badge.jpg",
      title: "Berjaya Langkawi Resort",
      subtitle: "Langkawi, Malaysia",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/e1155"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt512eb0497d9395f8/62739c65941a2939d3d00e41/swiss_belinn_badge.jpg",
      title: "Swiss-Belinn Legian",
      subtitle: "Bali, Indonesia",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/b6a11"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt33c763f7acfb7f8d/62739c653debbf3afdd2d7a5/wyndham_surabaya_badge.jpg",
      title: "Wyndham Surabaya City Centre",
      subtitle: "Surabaya, Indonesia",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/ec005"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blte1225d3a7c7fa37e/62eb27b15690027609753f80/royale_chulan_penang_badge.jpg",
      title: "Royale Chulan Penang",
      subtitle: "Penang, Malaysia",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/IP8740195DS"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/bltdb2c2e989004d013/62eb27b24c4bc9109f6969e0/zest_hotel_legian_badge.jpg",
      title: "Zest Hotel Legian",
      subtitle: "Bali, Indonesia",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/AA15725651DS"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt1034dd984cee0097/62739c659dad2234e4d02d2f/intercontinental_phuket_badge.jpg",
      title: "Intercontinental Phuket",
      subtitle: "Phuket, Thailand",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/6b35"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt75cc4687687e359c/62eb27b1145e5527a2b46d1d/astoria_current_badge.jpg",
      title: "Astoria Current",
      subtitle: "Boracay, Philippines",
      cta: "Book Now",
      url: "https://www.airasia.com/hotel/6850"
    }
  ],
}
